import { client } from "$api/client";

export const fetchCustomerCsv = async (notification, setIsLoading) => {
  let result;
  try {
    setIsLoading((isLoading) => ({ ...isLoading, export: true }));
    result = await client.get(`/csv_file/export`, {
      responseType: "blob",
    });
  } catch (error) {
    notification.error({
      message: "Fehler beim Exportieren der Kundendaten",
      description:
        "Die Datenbank ist möglicherweise leer oder es ist ein Fehler aufgetreten!",
    });
    setIsLoading((isLoading) => ({ ...isLoading, export: false }));
    return;
  }

  const url = window.URL.createObjectURL(result.data);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `customers.csv`);
  document.body.appendChild(link);

  link.click();
  link.parentNode.removeChild(link);

  notification.success({
    message: "Kundendaten erfolgreich exportiert",
    description: "Die CSV-Datei wurde vorbereitet.",
  });
  setIsLoading((isLoading) => ({ ...isLoading, export: false }));
};
